import { ToggleButton, ToggleButtonGroup } from "@mui/material";

import type { FC } from "react";

export type FeedView = "recently-edited" | "upcoming-sends";

const VIEWS: { value: FeedView; label: string }[] = [
  { value: "recently-edited", label: "Recently edited" },
  { value: "upcoming-sends", label: "Upcoming sends" },
];

/** Pills to switch the dashboard's feed between what was edited and what sends next. */
export const FeedToggle: FC<{ value: FeedView; onChange: (view: FeedView) => void }> = ({
  value,
  onChange,
}) => (
  <ToggleButtonGroup
    exclusive
    value={value}
    // Clicking the one already picked would pick none.
    onChange={(_, view: FeedView | null) => view && onChange(view)}
    aria-label="Dashboard feed"
    sx={{
      bgcolor: "action.selected",
      borderRadius: 999,
      p: 0.5,
      gap: 0.5,
      "& .MuiToggleButtonGroup-grouped, & .MuiToggleButtonGroup-grouped:not(:first-of-type)": {
        m: 0,
        border: 1,
        borderColor: "transparent",
        borderRadius: 999,
        px: 2,
        py: 0.75,
        typography: "subtitle1",
        textTransform: "none",
        color: "text.secondary",
      },
      "& .MuiToggleButtonGroup-grouped.Mui-selected, & .MuiToggleButtonGroup-grouped:not(:first-of-type).Mui-selected":
        {
          bgcolor: "background.paper",
          borderColor: "primary.main",
          color: "primary.main",
          "&:hover": { bgcolor: "background.paper" },
        },
    }}
  >
    {VIEWS.map(({ value: view, label }) => (
      <ToggleButton key={view} value={view} data-analytics-id={`dashboard-feed-${view}`}>
        {label}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
);
